<main>
    <h1 class="dialog-title dialog-title--bigger" *ngIf="isError===false">{{"DeleteWorkshop" | translate}}</h1>
    <h1 class="dialog-title dialog-delete-workshop__tittle--red" *ngIf="isError===true" >{{"ReassignEvents" | translate}}</h1>

    <mat-dialog-content>
        <p *ngIf="isError===false">
            {{"ConfirmationDeleteWorkshopFirstPart" | translate}} <strong>{{workshop.workshopName}}</strong> {{"ConfirmationDeleteWorkshopSecondtPart" | translate}}
        <p *ngIf="isError===true">
             {{"ReassignEventsPopUpFirstPartWorkshop" | translate}} <strong>{{workshop.workshopName}}</strong> {{"ReassignEventsPopUpSecondPart" | translate}}
        </p>
    </mat-dialog-content>

    <mat-dialog-actions align="center" *ngIf="isError===false">
        <button class="dialog__button" (click)="onCancel()">
            {{"Cancel" | translate}}
        </button>
        <button class="dialog__button dialog__button--fill" (click)="onSave()">
            {{"Accept" | translate}}
        </button>
    </mat-dialog-actions>
    
    <mat-dialog-actions align="center" *ngIf="isError===true">
        <button class="dialog__button dialog-delete-workshop__button--red" (click)="onSaveDisable()">
            {{"Accept" | translate}}
        </button>
    </mat-dialog-actions>
</main>
